/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";

import useTableFunctions from "@/components/Table/hooks/useTableFunctions";
import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

import { IntegrationsRow } from "../../../../../Pages/Integrations/types";
import {
  ACTIVITY_STATUS,
  Column,
  INVITATION_STATUS,
  TableRowData
} from "../../../../../shared";
import { useTableStyles } from "../../../styles/styles";

interface IMobileTableItemColumnProps {
  columnData: Column;
  row: TableRowData;
  onToggleChange?: (rowData: IntegrationsRow) => Promise<void>;
}

const MobileTableItemColumn = ({
  columnData,
  row,
  onToggleChange
}: IMobileTableItemColumnProps) => {
  const { renderValue } = useTableFunctions(onToggleChange);
  const { t } = useTranslation();

  const { mobileTableColumn, mobileTableColumnValue } = useTableStyles();

  const { name, isBadge, resource, secondCellValue } = columnData;

  const isDimmed =
    row.status === ACTIVITY_STATUS.Deactivated ||
    row?.invitationStatus === INVITATION_STATUS.Expired;

  const valueStyle = useMemo(
    () =>
      css([
        {
          color: isDimmed ? colors.textDisabled : colors.textDark,
          marginTop: isBadge ? "2px" : "0"
        },
        mobileTableColumnValue
      ]),
    [isDimmed, isBadge, mobileTableColumnValue]
  );

  return (
    <div css={mobileTableColumn}>
      <Typography variant="body4Medium" sx={{ color: colors.gray700 }}>
        {t(`Table##${name.toLowerCase()}`)}
      </Typography>
      <div css={valueStyle}>
        {renderValue(name, resource, row, secondCellValue)}
      </div>
    </div>
  );
};

export default React.memo(MobileTableItemColumn);
